import { AddressDto, CustomerPropertiesDto } from '@/api/generated';
import {
  addressTranslation,
  CustomerStatusOptionsTranslation,
  customerStatusOptionsTranslation,
  CustomerTypeOptionsTranslation,
  customerTypeOptionsTranslation,
  FlagOptionsTranslation,
  flagOptionsTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';

export type CustomerDetailsIndividualTranslation = {
  address: {
    fields: Record<keyof AddressDto, string>;
    title: string;
  };
  main: {
    fields: Record<keyof Omit<CustomerPropertiesDto, 'address'>, string> & {
      flagOptions: FlagOptionsTranslation;
      nipNotAvailable: string;
      statusOptions: CustomerStatusOptionsTranslation;
      typeOptions: CustomerTypeOptionsTranslation;
    };
    title: string;
  };
};

export const customerDetailsIndividualTranslation: CustomerDetailsIndividualTranslation = {
  address: {
    fields: addressTranslation,
    title: 'Dane adresowe',
  },
  main: {
    fields: {
      customerId: 'ID klienta',
      flag: 'Flaga',
      flagOptions: flagOptionsTranslation,
      name: 'Nazwa klienta',
      nip: 'NIP',
      nipNotAvailable: 'Brak numeru NIP',
      status: 'Status',
      statusOptions: customerStatusOptionsTranslation,
      type: 'Typ',
      typeOptions: customerTypeOptionsTranslation,
    },
    title: 'Dane klienta: {{clientName}}',
  },
};
